// 地区代码 -> IANA 时区标识符映射
export const REGION_TIMEZONE_MAP: Record<string, string> = {
  US: "America/New_York", // 美东时区（EDT/EST），包含缅因州（美国最东端）
  // 预留未来扩展，当前还未使用到
  GB: "Europe/London",
  ID: "Asia/Jakarta",
  VN: "Asia/Ho_Chi_Minh",
  TH: "Asia/Bangkok",
  MY: "Asia/Kuala_Lumpur",
  PH: "Asia/Manila",
  SG: "Asia/Singapore",
  MX: "America/Mexico_City",
  DE: "Europe/Berlin",
  FR: "Europe/Paris",
  IT: "Europe/Rome",
  ES: "Europe/Madrid",
  JP: "Asia/Tokyo",
  BR: "America/Sao_Paulo",
};

// 默认时区：美东时区
export const DEFAULT_TIMEZONE = "America/New_York";

// 时区显示名称映射
export const TIMEZONE_DISPLAY_NAMES: Record<string, string> = {
  "America/New_York": "Eastern Time (ET)",
  "Europe/London": "British Time (GMT/BST)",
  "Asia/Jakarta": "Western Indonesia Time (WIB)",
  "Asia/Ho_Chi_Minh": "Indochina Time (ICT)",
  "Asia/Bangkok": "Indochina Time (ICT)",
  "Asia/Kuala_Lumpur": "Malaysia Time (MYT)",
  "Asia/Manila": "Philippine Time (PHT)",
  "Asia/Singapore": "Singapore Time (SGT)",
  "America/Mexico_City": "Central Time (CT)",
  "Europe/Berlin": "Central European Time (CET)",
  "Europe/Paris": "Central European Time (CET)",
  "Europe/Rome": "Central European Time (CET)",
  "Europe/Madrid": "Central European Time (CET)",
  "Asia/Tokyo": "Japan Standard Time (JST)",
  "America/Sao_Paulo": "Brasilia Time (BRT)",
};

/**
 * 获取时区的显示名称
 * @param tz IANA 时区标识符
 * @returns 用户友好的时区显示名称
 */
export function getTimezoneDisplayName(tz: string): string {
  return TIMEZONE_DISPLAY_NAMES[tz] || tz;
}
